/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Stack } from "react-bootstrap";
import { TIMING_LIST_ITEM } from "../TimingList.renderer";
import { ITimingListProps, DefaultTimingListProps } from "../TimingList.types";
import TimingListStyles from "../TimingList.styles";
import { toCSSODateString } from "../../../../../shared/utils/data.utils";
import { TimingLabel } from "../../../../../shared/enums/labels.enums";

const SCHEDULING_TIMING_STACK: React.FC<ITimingListProps> = (
  /* istanbul ignore next */ props: ITimingListProps = DefaultTimingListProps
) => {
  const { timing } = props;

  return (
    <Stack data-testid="timing-scheduling-stack">
      <TIMING_LIST_ITEM
        label={TimingLabel.PROJECTED_END_DATE}
        value={toCSSODateString(
          /* istanbul ignore next */ timing?.projectedEndDate ?? null
        )}
      />
      <TIMING_LIST_ITEM
        label={TimingLabel.REQUESTED_BY_DATE}
        value={toCSSODateString(
          /* istanbul ignore next */ timing?.requestedByDate ?? null
        )}
      />
      <TimingListStyles.SchedulingText data-testid="timing-scheduling-text">
        <p>
          Our Scheduling team is reviewing your order requirements and
          coordinating necessary services to complete your project. We&#39;ll
          also arrange for an on-site inspection to ensure your site is
          construction-ready. Our team will be in contact with you as soon as we
          have a timeline for construction to begin.
        </p>
      </TimingListStyles.SchedulingText>
    </Stack>
  );
};

SCHEDULING_TIMING_STACK.defaultProps = DefaultTimingListProps;
export default SCHEDULING_TIMING_STACK;
